<template>
  <div class="header bg-blur">
    <div class="d-flex justify-content-between align-center">
      <!-- <img src="@/assets/logo-top.png" class="logo"/> -->
      <a class="header-logo" href="/home"
        ><img src="@/assets/icon.png" class="logo" />冀时安全</a
      >
      <a
        @click="toLogin"
        class="btn btn-outline-primary btn-round"
        v-if="!isLogin"
        >微信扫码登录</a
      >
      <div class="dropdown" v-if="isLogin">
        <button
          class="btn btn-primary dropdown-toggle"
          type="button"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          个人中心
        </button>
        <ul class="dropdown-menu">
          <li>
            <router-link class="dropdown-item" :to="{ name: 'MyProfile' }"
              >个人中心</router-link
            >
          </li>

          <li><a class="dropdown-item" @click="toLogout">退出登录</a></li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      hasLogin: this.$store.getters.hasLogin,
    };
  },
  created() {},
  computed: {
    isLogin() {
      let token = window.localStorage.getItem("token");
      if (!token) {
        this.$store.commit("setToken", "");
      } else {
        this.$store.commit("setToken", token);
      }
      return this.$store.getters.hasLogin;
    },
    userInfo() {
      return this.$store.state.userInfo;
    },
  },
  watch: {
    $route(to, from) {
      this.curPage = to.path;
      var path = to.path;
      if (path.indexOf("news/") != -1) {
        path = "/news";
        this.curPage = path;
      }
      window.localStorage.setItem("headerName", path);
    },
  },
  methods: {
    toLogin() {
      //LQ user
      // let userJson =
      //   '{"member_id":"3","username":null,"mobile":"15076137034","email":"","nickname":"Ivy liang","real_name":"梁青","company":"","company_type":"0","company_option_id":"0","company_completed":"0","position":"企业单位","industry":"法律法规,金属非金属矿山","avatar":"https://thirdwx.qlogo.cn/mmopen/vi_32/PiajxSqBRaEK7MhEO8GxP1QpDMS0iavj6cv2EfOhLBm56E9uiccIWFRzcBRTlwzc7ORudavicM5zGtXPGscKhNAr5g/132","role_id":"0","is_completed":"1","province":"河北省","city":"张家口市","district":"张北县","street":"张北镇","province_code":"130000","city_code":"130700","district_code":"130707","region":"130707001","points":0,"total_points":0,"last_login":"2024-05-14 13:40:28","is_volunteer":"1","is_volunteer_group":"0","is_company":"2","event_duration":"33:00:00","event_count":"1","love_points":"5","power":50,"volunteer":null,"volunteer_group":null,"company_name":"长安安全服务","manager_position":"工长","company_city":"石家庄市","company_district":"长安区","company_city_code":"130100","company_district_code":"130102","can_exchange":0}';
      // window.localStorage.setItem("userInfo", userJson);
      // window.localStorage.setItem(
      //   "token",
      //   "o84k840occ8ookcogc08wc44gocc0gc0sw0kwcow.k4BRDq9X0lxuOqcSbEdjxg=="
      // );
      // this.$store.dispatch("updateUser", JSON.parse(userJson));

      // 了了user
      // let userJson =
      //   '{"member_id":"4814673","username":null,"mobile":"99999999999","email":"","nickname":"微信用户","real_name":"lim","company":"","company_type":"1","company_option_id":"5","position":"党政机关","industry":"金属非金属矿山","avatar":"https://thirdwx.qlogo.cn/mmopen/vi_32/POgEwh4mIHO4nibH0KlMECNjjGxQUq24ZEaGT4poC6icRiccVGKSyXwibcPq4BWmiaIGuG1icwxaQX6grC9VemZoJ8rg/132","role_id":"0","is_completed":"1","province":"河北省","city":"石家庄市","district":"市安委会成员单位","street":"市安委会成员单位","province_code":"130000","city_code":"130100","district_code":"130101","region":"130101001","points":0,"total_points":0,"last_login":"2024-05-09 18:33:19","is_volunteer":"0","is_volunteer_group":"0","is_company":"0","event_duration":"00:00:00","event_count":"0","love_points":"0","power":1,"volunteer":null,"volunteer_group":null,"company_name":"","manager_position":"","company_city":"","company_district":"","company_city_code":"","company_district_code":"","can_exchange":0}';
      // window.localStorage.setItem("userInfo", userJson);
      // window.localStorage.setItem(
      //   "token",
      //   "w8kgg44w480okok8k4kgwg00ok04kwk4s4scss8s.v4hBq4yatjEJaArrP3aVzQ=="
      // );
      // this.$store.dispatch("updateUser", JSON.parse(userJson));

      // 客户
      // let userJson =
      //   '{"member_id":"47","username":null,"mobile":"19933333211","email":"","nickname":"sonntag","real_name":"王莺","company":"雄安新区应急管理","position":"党政机关","industry":"公共部分","avatar":"https://thirdwx.qlogo.cn/mmopen/vi_32/Q0j4TwGTfTIQRRPicSBhK1nb7GORP8xI0KeJBvn6YsE4SKwEyMmccG8h0IWuuyMe0tDEicy07XxRDHhbiakTKd2gA/132","role_id":"0","is_completed":"1","province":"河北省","city":"雄安新区","district":"新区管委会","street":"应急管理局","province_code":"130000","city_code":"132300","district_code":"132301","region":"132301009","points":0,"total_points":5063,"last_login":"2024-01-24 17:32:09","is_volunteer":"1","is_volunteer_group":"1","is_company":"0","event_duration":"00:00:00","event_count":"0","love_points":"1","power":50,"volunteer":{"volunteer_id":"819","member_id":"47","real_name":"王莺","mobile":"19933333211","gender":"2","position":"党政机关","company":"雄安新区应急管理","province":"河北省","city":"雄安新区","district":"新区管委会","street":"应急管理局","province_code":"130000","city_code":"132300","district_code":"132301","street_code":"132301009","industry":"安全宣传","status":"1","created_at":"2023-08-23 17:46:09"},"volunteer_group":{"volunteer_group_id":"124","member_id":"47","real_name":"王莺","mobile":"19933333211","position":"党政机关","company":"雄安新区应急管理","orga_name":"雄安新区安全宣传志愿者","province":"河北省","city":"雄安新区","district":"新区管委会","street":"应急管理局","province_code":"130000","city_code":"132300","district_code":"132301","street_code":"132301009","industry":"安全宣传","logo":"","intro":"雄安新区安全宣传志愿者是从事安全生产、防灾减灾、应急管理安全宣传的团体，隶属于雄安新区应急管理局，常年开展的志愿活动项目有“安全带回家，祥和过大年”“安全进万家，幸福你我他”“青春扬帆，安全护航”“12350—安全伴你行”等志愿服务活动。","intro_images":"","content":null,"status":"1","created_at":"2023-08-22 17:54:18","apply_status":2},"company_name":"","manager_position":"","company_city":"","company_district":"","company_city_code":"","company_district_code":"","can_exchange":0}';
      // window.localStorage.setItem("userInfo", userJson);
      // window.localStorage.setItem(
      //   "token",
      //   "408wos444o4cosc4cckkkcswksko08k8g8og4o0k.WMd3Nh3CcIMGQjVB7wbBEg=="
      // );
      // this.$store.dispatch("updateUser", JSON.parse(userJson));

      window.location.href =
        "https://open.weixin.qq.com/connect/qrconnect?appid=wx1f87fe48fc7f8de1&redirect_uri=https://hbemergency.hbzhengwu.com/&response_type=code&scope=snsapi_login&state=STATE#wechat_redirect";
    },
    toLogout() {
      this.$store.dispatch("logout");
      this.$router.replace({
        path: "/",
      });
    },
  },
};
</script>

<style></style>
